let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7SdSK")).then(() => parcelRequire('i8jzO'));